var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.196,
    height: 35.492,
    viewBox: "0 0 195.196 35.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0 -13.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(42.009 15.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M216.513,46.1a7.207,7.207,0,0,1,6.457,3.471V46.382H225.9V72.109H222.97v-11.5a7.418,7.418,0,0,1-6.558,3.511c-4.621,0-8.212-3.672-8.212-9.08C208.2,49.611,211.792,46.1,216.513,46.1Zm.525,2.522c-3.188,0-5.892,2.32-5.892,6.437s2.7,6.537,5.892,6.537,5.932-2.381,5.932-6.5C222.97,51.043,220.226,48.622,217.038,48.622Z",
    transform: "translate(-208.2 -39.603)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M335.037,64.953h-2.906V62.371a6.4,6.4,0,0,1-5.569,2.825c-4.015,0-7.163-2.482-7.163-7.486V47.5h2.865v9.847c0,3.531,1.937,5.347,4.863,5.347,2.986,0,5-1.856,5-5.609V47.5h2.906Z",
    transform: "translate(-296.963 -40.72)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M418.9,15.877a1.947,1.947,0,1,1,1.977,1.977A1.955,1.955,0,0,1,418.9,15.877Zm.464,4.8h2.906V38.133h-2.906Z",
    transform: "translate(-376.386 -13.9)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M463.294,46.1c4.338,0,7.163,2.22,8.051,5.892h-3.128a4.758,4.758,0,0,0-4.943-3.43c-3.188,0-5.549,2.26-5.549,6.537,0,4.338,2.361,6.6,5.549,6.6a4.706,4.706,0,0,0,4.943-3.43h3.128c-.888,3.471-3.733,5.892-8.051,5.892-4.964,0-8.495-3.511-8.495-9.039C454.779,49.611,458.311,46.1,463.294,46.1Z",
    transform: "translate(-405.042 -39.603)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M555.9,17.2h2.906V31.062l6.719-7.748h4.035l-8.212,8.7,8.253,8.757h-3.955l-6.84-7.708v7.708H555.9Z",
    transform: "translate(-485.743 -16.534)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M639.543,64.2c-4.076,0-6.941-2.22-7.143-5.408h2.986c.161,1.695,1.655,2.966,4.116,2.966,2.3,0,3.571-1.15,3.571-2.583,0-3.894-10.311-1.614-10.311-8.111,0-2.684,2.522-4.863,6.4-4.863,3.854,0,6.4,2.078,6.6,5.468h-2.906c-.121-1.755-1.473-3.027-3.793-3.027-2.139,0-3.41,1.029-3.41,2.421,0,4.136,10.129,1.876,10.25,8.111C645.919,62.039,643.4,64.2,639.543,64.2Z",
    transform: "translate(-546.808 -39.683)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M728.943,46.1c4.681,0,8.273,3.511,8.273,8.959,0,5.408-3.591,9.08-8.273,9.08a7.548,7.548,0,0,1-6.537-3.511v11.5H719.5V46.382h2.906v3.208A7.4,7.4,0,0,1,728.943,46.1Zm-.605,2.522c-3.148,0-5.932,2.421-5.932,6.457,0,4.116,2.764,6.5,5.932,6.5,3.208,0,5.932-2.421,5.932-6.537C734.25,50.943,731.546,48.622,728.338,48.622Z",
    transform: "translate(-616.333 -39.603)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M829.6,64.118c-4.943,0-8.7-3.511-8.7-9.039a8.539,8.539,0,0,1,8.818-8.979c4.964,0,8.818,3.471,8.818,8.979A8.639,8.639,0,0,1,829.6,64.118Zm0-2.542c3.027,0,5.993-2.078,5.993-6.5,0-4.4-2.906-6.457-5.892-6.457-3.067,0-5.831,2.078-5.831,6.457C823.866,59.5,826.57,61.576,829.6,61.576Z",
    transform: "translate(-697.273 -39.603)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M921.46,32.5H919.2V30.1h2.26V25.7h2.906v4.4h4.56V32.48h-4.56V42.77c0,1.715.646,2.32,2.421,2.32h2.139v2.462h-2.6c-3.087,0-4.843-1.271-4.843-4.782V32.5Z",
    transform: "translate(-775.739 -23.319)",
    fill: "#f15c60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 13.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M111.6,113.706l.585.343v5.69l-6.578-3.733-8.959-5.085-.081-.04-.363-.2,4.6-2.6,1.856-1.049,6.376-3.592,1.836-1.029,1.412-.807v.545c0,.363-.02.706-.02,1.049-.04.666-.121,1.312-.222,1.957a17.5,17.5,0,0,1-2.946,7.143l2.5,1.412Z",
    transform: "translate(-76.789 -84.369)",
    fill: "#a64697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M15.759,42.087,11.441,44.67,9.584,45.78l-6.4,3.814h0L1.453,50.622.04,51.47C.02,51.086,0,50.7,0,50.32v-.5c.02-.646.081-1.291.161-1.937A17.813,17.813,0,0,1,6.356,36.7l3.208,1.856,1.856,1.069,4.338,2.462Z",
    transform: "translate(0 -32.564)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M55.481,17.33V28.407L50.76,25.683l-1.776-1.029-6.094-3.491-1.856-1.069L39.4,19.146q.787-.515,1.634-.969c.605-.3,1.231-.585,1.856-.827a17.72,17.72,0,0,1,6.316-1.15A17.489,17.489,0,0,1,55.481,17.33Z",
    transform: "translate(-31.45 -16.2)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M10.7,92v18.22c-.484-.262-.969-.525-1.433-.827a18.762,18.762,0,0,1-1.634-1.19A17.777,17.777,0,0,1,1.4,97.569l2.966-1.776L6.1,94.764,10.7,92Z",
    transform: "translate(-1.118 -76.706)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M72.479,143c-.424.262-.868.525-1.332.767-.605.3-1.231.585-1.856.827a17.937,17.937,0,0,1-6.275,1.13,17.72,17.72,0,0,1-6.316-1.15V134l4.338,2.482,1.856,1.069,6.4,3.652,1.856,1.069,1.332.726Z",
    transform: "translate(-45.259 -110.231)",
    fill: "#f15c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M137.743,39.216l-3.087,1.755L132.82,42l-4.52,2.563V26c.444.222.888.484,1.312.747a15.092,15.092,0,0,1,1.594,1.13,17.689,17.689,0,0,1,6.537,11.34Z",
    transform: "translate(-102.412 -24.023)",
    fill: "#f15c60"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57cf110953a9dd284278f532e300c890.svg";
export { ForwardRef as ReactComponent };